// extracted by mini-css-extract-plugin
export default {"ReplyButton":"qa_a bih_wx bih_jb bih_xl bih_i bih_j bih_q bih_vt bih_et bih_so bih_sp bih_eg","ReplyButton__icon":"qa_b bih_rz"};